import React from 'react';

interface LoadingStateProps {
  label?: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({ label = 'Loading…' }) => (
  <div className="flex flex-col items-center justify-center gap-s3 py-s7 px-s5 text-center">
    <span className="inline-block h-5 w-5 animate-spin rounded-full border-2 border-ink3 border-t-transparent" />
    <span className="text-[12px] text-ink3 font-sans">{label}</span>
  </div>
);

interface ErrorStateProps {
  message: string;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ message }) => (
  <div className="flex flex-col items-center justify-center gap-s2 py-s7 px-s5 text-center">
    <span className="font-serif text-[18px] text-ink1">Something went wrong</span>
    <span className="text-[13px] text-ink2 font-sans max-w-xs">{message}</span>
  </div>
);

interface EmptyStateProps {
  title: string;
  body?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ title, body }) => (
  <div className="flex flex-col items-center justify-center gap-s2 py-s7 px-s5 text-center">
    <span className="font-serif text-[20px] text-ink1">{title}</span>
    {body ? <span className="text-[13px] text-ink2 font-sans max-w-xs">{body}</span> : null}
  </div>
);
